import { render, staticRenderFns } from "./EpreuveItem.vue?vue&type=template&id=5673c348"
import script from "./EpreuveItem.vue?vue&type=script&lang=js"
export * from "./EpreuveItem.vue?vue&type=script&lang=js"
import style0 from "./EpreuveItem.vue?vue&type=style&index=0&id=5673c348&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports